var _rect, _rect2, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 40,
    viewBox: "0 0 95 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 93,
    height: 39,
    rx: 19.5,
    stroke: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2122_9209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2122_9209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27.2499V12.75L33.2114 19.9999L16 27.2499ZM17.5 24.9999L29.35 19.9999L17.5 14.9999V18.6923L22.923 19.9999L17.5 21.3076V24.9999Z",
    fill: "#575D62"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.156 22.912H43.66C43.964 24.24 44.876 24.96 46.476 24.96C48.22 24.96 48.908 24.144 48.908 23.104C48.908 21.984 48.364 21.36 46.124 20.816C43.5 20.176 42.588 19.28 42.588 17.712C42.588 16.064 43.82 14.72 46.3 14.72C48.956 14.72 50.044 16.256 50.188 17.712H48.684C48.492 16.72 47.868 15.904 46.252 15.904C44.892 15.904 44.124 16.512 44.124 17.584C44.124 18.624 44.764 19.04 46.7 19.504C49.884 20.288 50.444 21.52 50.444 22.944C50.444 24.736 49.116 26.144 46.396 26.144C43.596 26.144 42.38 24.624 42.156 22.912ZM52.3559 14.256H53.7639V19.088C54.1799 18.384 54.9159 17.696 56.2919 17.696C57.5879 17.696 59.0279 18.416 59.0279 20.832V26H57.6359V21.056C57.6359 19.68 57.0439 18.912 55.8759 18.912C54.4039 18.912 53.7639 19.888 53.7639 21.568V26H52.3559V14.256ZM67.3726 20.368V24.24C67.3726 24.976 67.4366 25.776 67.4846 26H66.1406C66.0766 25.824 66.0286 25.44 66.0126 24.944C65.7246 25.488 65.0846 26.192 63.5166 26.192C61.5966 26.192 60.7806 24.96 60.7806 23.728C60.7806 21.904 62.2046 21.088 64.6206 21.088C65.1806 21.088 65.6926 21.088 65.9966 21.088V20.384C65.9966 19.68 65.7726 18.8 64.2526 18.8C62.8926 18.8 62.6686 19.472 62.5246 20.112H61.1646C61.2766 18.992 61.9646 17.696 64.3006 17.696C66.2846 17.712 67.3726 18.512 67.3726 20.368ZM66.0126 22.32V22.048C65.7406 22.048 65.1326 22.048 64.7006 22.048C63.0686 22.048 62.2046 22.496 62.2046 23.648C62.2046 24.48 62.7966 25.104 63.7886 25.104C65.7406 25.104 66.0126 23.792 66.0126 22.32ZM69.7934 26V20.096C69.7934 18.96 69.7934 18.32 69.7774 17.888H71.1534C71.1854 18.128 71.2014 18.752 71.2014 19.552C71.6174 18.448 72.5934 17.744 73.9374 17.696V19.104C72.2734 19.152 71.2014 20.016 71.2014 22.064V26H69.7934ZM81.8534 22.208H76.1414C76.1414 23.856 76.9734 25.024 78.3494 25.024C79.6454 25.024 80.0614 24.368 80.3174 23.776H81.7254C81.4054 24.816 80.5414 26.192 78.3174 26.192C75.7574 26.192 74.7174 24.128 74.7174 22.032C74.7174 19.632 75.9334 17.696 78.3974 17.696C81.0214 17.696 81.8854 19.808 81.8854 21.536C81.8854 21.776 81.8854 21.984 81.8534 22.208ZM76.1894 21.216H80.4614C80.4454 19.888 79.7734 18.816 78.3814 18.816C76.9574 18.816 76.3334 19.808 76.1894 21.216Z",
    fill: "#575D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.b54ca5b58af1b7e040d9f1b482670d4f.svg";
export { ForwardRef as ReactComponent };